// extracted by mini-css-extract-plugin
export var wrapper = "SectionLayout-module--wrapper--3udpi";
export var container = "SectionLayout-module--container--1nBZf";
export var layout = "SectionLayout-module--layout--2lEWA";
export var main = "SectionLayout-module--main--bkerJ";
export var imageContainer = "SectionLayout-module--imageContainer--3rDLw";
export var imageTitle = "SectionLayout-module--imageTitle--1miFh";
export var image = "SectionLayout-module--image--1yS6A";